var Friends_UI = {
	
	// Collapse/expand movement header on scroll
	$UI: null,
	$Footer_Trigger: null,
	Footer_Threshold: null, 
	/*
	$Video_Trigger: null,
	$Splash_Trigger: null,
	*/
	Is_Mobile: false,
	Is_Tablet: false,
	Is_iOS_Safari: false,
	Has_Feature_Passive: false,
	fsClientId: 'N2ZZEARF1AC5YNKBI01QKADKAQAHT1ZUG4B0MX3BE5HIMD3W',
	fsClientSecret: 'KPZYLQGC5KFIMYYVPGWB51BE1INZJMAX4CWFBOXWTT5FLKNT',
	rem: null
	

	, connection: { 
			
			// Mostly a hack 
			show_bad_connection_dialog: function () { 
				if ($('.Friends_Bad_Connection').length) { 
					$('.Friends_Bad_Connection').css('display', 'flex');
					$('#Toolbar_Wrapper').css('top', '50px');
					$('#Content_Wrapper').css('padding-top', '50px');
				}
			}
		, hide_bad_connection_dialog: function () {
				if ($('.Friends_Bad_Connection').length) { 
					$('.Friends_Bad_Connection').hide();
					$('#Toolbar_Wrapper').css('top', '0px');
					$('#Content_Wrapper').css('padding-top', '0px');
				}
			}
		}
	, sharing: { 
			share: function(social_network, url, message, tracking_data) {

				// track
				if (window.mixpanel) { 
					mixpanel.track("Shared", {
						 	On: social_network

						, Movement: tracking_data.movement
						, Event: tracking_data.event
						, Relationship: tracking_data.relationship
						, Just_Supported: tracking_data.just_supported
						, Has_Testimonial: tracking_data.has_testimonial
						, Message: tracking_data.message

						, Is_New: true
					});
				}

				// If relationship = organizer, track server-side --- but I'm not tracking sharing events.
				if (tracking_data.relationship == "Organizer") {
					$.get("/action/6676/execute/raw" + ":" + Jelly.Utilities.Serialize({Token: ",", Values: {
							kind: "Shared"
						,	movement: tracking_data.movement
						, 	event: tracking_data.event
						,	user_is: "agent"
						, 	category: social_network
					}}));
				}

				// facebook, twitter (link doesn't do anything but track above.)
				switch (social_network.toLowerCase()) { 
					case "twitter":
						// TODO:  dual monitor http://jsfiddle.net/w665x/138/
						var screen_left_boundary = (window.screenLeft ? window.screenLeft : (window.screenX ? window.screenX : 0));
						var screen_top_boundary = (window.screenTop ? window.screenTop : (window.screenY ? window.screenY : 0));
						
						var popup_width = 550;
						var popup_height = 230;

						var popup_parameters = {
								left: screen.width/2 - popup_width/2 + screen_left_boundary
							, top: screen.height/2 - popup_height/2 + screen_top_boundary
							, width: popup_width
							, height: popup_height
							,	menubar: "no"
							, toolbar: "no"
							, location: "no"
							, personalbar: "no"
							, status: "no"
							, resizeable: "yes"
							, scrollbars: "yes"
						};

						href_parameters = {};
						if (message) {href_parameters.text = message;}
						if (url) {href_parameters.url = url;}
						href = "https://twitter.com/intent/tweet?" + Object.keys(href_parameters).map(function(k){return (k + "=" + href_parameters[k]);}).join("&");

						window.open(
							href, 
							'wf-twitter', 
							Object.keys(popup_parameters).map(function(k){return (k + "=" + popup_parameters[k]);}).join(",")
						);
						break;

					case "facebook":
						FB.ui({
										method: "share"
									,	href: url
									, quote: message
									, display: 'popup'
								} 
							, function(response){}
						);
						break;
					case "email":
						window.open(
							url,
							'wf-email'
						)
						break;
					case "instagram": 
						break;
					case "link":
						break;
				}
			}
		}

	, entries: { 
			list: null // The infinity list
		, event_id: null // for entry chunking for no reason really.
		, event_name: null // for tiered tickets hack...
		, can_refund: false
		, can_view_entry_contact: false
		, can_resend_ticket_confirmation: false
		, $list: null // The DOM-jQuery item
		, filter_query: "" // The current filter query
		, filtered_list: null // The infinity list for a searched view
		, $filtered_list: null // The DOM-jQuery item for a searched view
		, entries: null // The data
		,	$items: null // The items in the infinity list
		, check_in_action_namespace: null // Stores the name we need to execute check in actions
		, $incoming_divider: null // This is to overcome an AirBNB infinite bug
		, block_updates: {} // This makes our polling system not overpower a recent change
		, render_session_id: 0 // This allows you to interrupt async executions for example by switching tiers.

		// Takes the entries, creates $items sorted by dividers, and displays the $items via AirBNB infinity
		, render: function() {	

				// Set this apart from last session (cancels asyncs.)
				Friends_UI.entries.render_session_id++;

				// Clear existing AirBNB infinity  list
				if (Friends_UI.entries.list) { 
					Friends_UI.entries.list.remove();
					Friends_UI.entries.list = null;
				}

				// Create new AirBNB infinity list
				Friends_UI.entries.list = new infinity.ListView(Friends_UI.entries.$list);
				

				// Clear items
				Friends_UI.entries.$items = [];

				// sort entries
				// ... TODO

				// creates $items and dividers from entries
				var last_first_char = null;
				$.each(Friends_UI.entries.entries, function(entry_index, entry_value){

					// Get first letter
					var first_char;
					if (entry_value.last_name)
						first_char = entry_value.last_name.charAt(0).toLowerCase();
				 	else if (entry_value.first_name)
				 		first_char = entry_value.first_name.charAt(0).toLowerCase();

				 	// Bug catcher
				 	else 
				 		first_char = '*';

					// Add divider as needed
					if (first_char != last_first_char) {
						var $divider = $("<li>")
							.addClass("Divider")
							.css("background", "#F8C3E3")
							.css("padding", ".65rem")
							.css("padding-left", "1rem")
							.css("font-weight", "bold")
							.css("font-size", "1.1em")
							.css("position", "relative")
							.css("top", "-1px")
							.html(first_char.toUpperCase());
						Friends_UI.entries.$items.push($divider);
					}

					new_$item = Friends_UI.entries.create_$item(entry_value);
					// store $item in entry... for AirBNB hack
					entry_value.$item = new_$item;
					Friends_UI.entries.$items.push(new_$item);

					// Keep track of divider need
					last_first_char = first_char;
				});

				// Display $items  via airnbinfinity
				$.each(Friends_UI.entries.$items, function(item_index, $item_value) { 
					Friends_UI.entries.list.append($item_value);
					if ($item_value.entry)
						Friends_UI.entries.attach_handlers($item_value);
				});


				/*
				// rerender
				var loading_promises = [];
				$.each(Friends_UI.entries.entries, function(entry_index, entry_value){
					loading_promises.push($.getJSON('/shopping_cart/' + entry_value.id + '/entry', null, function(data){
						Friends_UI.entries.update_entries(data);
					}));
				});
				
				// stop showing loading indicator
				$.when.apply($, loading_promises).then(function(){
					$('.Guest_List_Loading').hide();
				});
				*/

				// Rerender, but only take 6 requests at a time.
				var loading_asyncs = [];
				var loading_async_verification_id = Friends_UI.entries.render_session_id;

				var entry_chunk_counter = 0;
				var entry_chunks = [];
				$.each(Friends_UI.entries.entries, function(entry_index, entry_value){
					
					entry_chunks[entry_chunk_counter] = entry_value;
					entry_chunk_counter++;

					if (entry_chunk_counter == 25 || entry_index == Friends_UI.entries.entries.length - 1) { 
						var internal_entry_chunks = entry_chunks;
						loading_asyncs.push(function(callback){
							if (loading_async_verification_id == Friends_UI.entries.render_session_id) { 
								console.log(loading_async_verification_id + " vs " + Friends_UI.entries.render_session_id);

								// Build chunky URL
								var url = '/event/' + Friends_UI.entries.event_id + '/entry_chunk:';
								$.each(internal_entry_chunks, function(entry_chunk_index, entry_chunk_value){
									console.log("HI");

									url += ',item_' + (entry_chunk_index + 1) + '_shopping_cart_id=' + entry_chunk_value.id;
									url += ',item_' + (entry_chunk_index + 1) + '_shopping_cart_item_id=' + entry_chunk_value.shopping_cart_item_id;
								});
								if (Friends_UI.entries.can_view_entry_contact) {
									url += ",include_entry_contact=1";
								}

								// Get chunky URL.
								$.getJSON(url, null, function(data){
									$.each(data, function(data_index, data_value) {
										Friends_UI.entries.update_entries(data_value);
									});
									callback();
								});
							}
							else {
								console.log("blocked");
							}
						});

						// Reset
						entry_chunk_counter = 0;
						entry_chunks = [];
					}					
				});

				async.parallelLimit(loading_asyncs, 6, function(){
					if (loading_async_verification_id == Friends_UI.entries.render_session_id){
						$('.Guest_List_Loading').hide();
						Jelly.Actions.Update_Check_In({'Count_Checks':true});
					}
				});

			}

		, remove_entry: function(shopping_cart_item_id) {
				var entry_removed = false;
				var active_filter_query = Friends_UI.entries.filter_query;

				if (!Friends_UI.entries.entries) {
					return false;
				}

				Friends_UI.entries.entries = $.grep(Friends_UI.entries.entries, function(entry){
					if (String(entry.shopping_cart_item_id) == String(shopping_cart_item_id)) {
						entry_removed = true;
						return false;
					}
					return true;
				});

				if (!entry_removed) {
					return false;
				}

				Friends_UI.entries.filter_query = "";
				if (Friends_UI.entries.filtered_list) {
					Friends_UI.entries.filtered_list.remove();
					Friends_UI.entries.filtered_list = null;
				}
				Friends_UI.entries.$filtered_list.hide();
				Friends_UI.entries.$list.show();

				Friends_UI.entries.render();
				if (active_filter_query) {
					Friends_UI.entries.filter(active_filter_query);
				}
				Jelly.Actions.Update_Check_In({"Count_Checks": true});

				return true;
			}

		// Add the checkbox handler
		, attach_handlers: function($displayed_item) { 

				$(document).off("click.entry_actions").on("click.entry_actions", function(){
					$(".Entry_Actions.Active")
						.removeClass("Active")
						.find(".Entry_Actions_Menu")
						.hide();
				});

				$displayed_item.find(".Entry_Actions_Trigger").off("click.entry_actions").on("click.entry_actions", function(event){
					event.preventDefault();
					event.stopPropagation();

					var $actions = $(this).closest(".Entry_Actions");
					var is_active = $actions.hasClass("Active");

					$(".Entry_Actions.Active")
						.not($actions)
						.removeClass("Active")
						.find(".Entry_Actions_Menu")
						.hide();

					$actions.toggleClass("Active", !is_active);
					$actions.find(".Entry_Actions_Menu").toggle(!is_active);
				});

				$displayed_item.find(".Entry_Actions_Menu").off("click.entry_actions").on("click.entry_actions", function(event){
					event.stopPropagation();
				});

				var reset_copy_email_feedback = function($link) {
					window.clearTimeout($link.data("entry-copy-email-timeout"));
					$link
						.removeClass("Copied Copy_Error")
						.html("Copy email address")
						.prop("disabled", false)
						.css({
								background: "transparent"
							,	color: "#333"
						});
				};

				var show_copy_email_feedback = function($link, message, is_error) {
					var $actions = $link.closest(".Entry_Actions");

					window.clearTimeout($link.data("entry-copy-email-timeout"));
					$link
						.toggleClass("Copied", !is_error)
						.toggleClass("Copy_Error", !!is_error)
						.html(message)
						.prop("disabled", true)
						.css({
								background: is_error ? "#fff0f0" : "#fdeaf5"
							,	color: is_error ? "#9b1c1c" : "#333"
						});

					$link.data("entry-copy-email-timeout", window.setTimeout(function(){
						$actions
							.removeClass("Active")
							.find(".Entry_Actions_Menu")
							.hide();
						reset_copy_email_feedback($link);
					}, is_error ? 1800 : 1000));
				};

				var copy_text_with_selection = function(value) {
					var text_area = document.createElement("textarea");
					var successful = false;

					text_area.value = value;
					text_area.setAttribute("readonly", "");
					text_area.style.position = "fixed";
					text_area.style.top = "0";
					text_area.style.left = "0";
					text_area.style.width = "2em";
					text_area.style.height = "2em";
					text_area.style.padding = "0";
					text_area.style.border = "none";
					text_area.style.outline = "none";
					text_area.style.boxShadow = "none";
					text_area.style.background = "transparent";

					document.body.appendChild(text_area);
					text_area.focus();
					text_area.select();

					try {
						successful = document.execCommand("copy");
					}
					catch (error) {
						successful = false;
					}

					document.body.removeChild(text_area);
					return successful;
				};

				var fallback_copy_entry_email_address = function(email_address) {
					return new Promise(function(resolve, reject) {
						if (copy_text_with_selection(email_address)) {
							resolve();
						}
						else if (Jelly.Utilities && Jelly.Utilities.Copy_To_Clipboard) {
							Jelly.Utilities.Copy_To_Clipboard(email_address);
							resolve();
						}
						else {
							reject();
						}
					});
				};

				var copy_entry_email_address = function(email_address) {
					if (window.navigator && window.navigator.clipboard && window.navigator.clipboard.writeText) {
						return window.navigator.clipboard.writeText(email_address)
							.catch(function(){
								return fallback_copy_entry_email_address(email_address);
							});
					}

					return fallback_copy_entry_email_address(email_address);
				};

				$displayed_item.find(".Entry_Copy_Email_Link").off("click.entry_copy_email").on("click.entry_copy_email", function(event){
					event.preventDefault();
					event.stopPropagation();

					if ($(this).prop("disabled") || $(this).hasClass("Disabled")) {
						return false;
					}

					var $copy_link = $(this);
					var email_address = $copy_link.attr("data-email-address") || $copy_link.data("email-address");
					if (!email_address) {
						return false;
					}

					copy_entry_email_address(email_address)
						.then(function(){
							show_copy_email_feedback($copy_link, "Copied", false);
						})
						.catch(function(){
							show_copy_email_feedback($copy_link, "Could not copy", true);
						});

					return false;
				});

				$displayed_item.find(".Entry_Refund_Link").off("click.entry_refund").on("click.entry_refund", function(event){
					event.preventDefault();
					event.stopPropagation();
					$(".Entry_Actions.Active")
						.removeClass("Active")
						.find(".Entry_Actions_Menu")
						.hide();
					Jelly.Handlers.Visit_Link({
							URL: $(this).attr("href")
						,	Container: "Modal"
						,	Alias: "Modal"
						,	Keep_Unlocked: true
						,	Calling_Element: this
					});
					});

				var reset_resend_ticket_confirmation_feedback = function($link) {
					window.clearTimeout($link.data("entry-resend-ticket-confirmation-timeout"));
					$link
						.removeClass("Sending Sent Send_Error")
						.html("Resend confirmation email")
						.prop("disabled", false)
						.attr("aria-busy", "false")
						.css({
								background: "transparent"
							, color: "#333"
						});
				};

				var show_resend_ticket_confirmation_feedback = function($link, message, state) {
					var $actions = $link.closest(".Entry_Actions");
					var is_sending = state == "sending";
					var is_error = state == "error";

					window.clearTimeout($link.data("entry-resend-ticket-confirmation-timeout"));
					$link
						.toggleClass("Sending", is_sending)
						.toggleClass("Sent", state == "sent")
						.toggleClass("Send_Error", is_error)
						.html(message)
						.prop("disabled", true)
						.attr("aria-busy", is_sending ? "true" : "false")
						.css({
								background: is_error ? "#fff0f0" : "#fdeaf5"
							, color: is_error ? "#9b1c1c" : "#333"
						});

					if (!is_sending) {
						$link.data("entry-resend-ticket-confirmation-timeout", window.setTimeout(function(){
							$actions
								.removeClass("Active")
								.find(".Entry_Actions_Menu")
								.hide();
							reset_resend_ticket_confirmation_feedback($link);
						}, is_error ? 5000 : 6000));
					}
				};

				$displayed_item.find(".Entry_Resend_Ticket_Confirmation_Link").off("click.entry_resend_ticket_confirmation").on("click.entry_resend_ticket_confirmation", function(event){
					event.preventDefault();
					event.stopPropagation();

					var $resend_link = $(this);
					if ($resend_link.prop("disabled") || $resend_link.hasClass("Disabled")) {
						return false;
					}

					var receipt_url = $resend_link.attr("data-send-ticket-receipt-url");
					if (!receipt_url) {
						show_resend_ticket_confirmation_feedback($resend_link, "Could not find this order email.", "error");
						return false;
					}

					show_resend_ticket_confirmation_feedback($resend_link, "Sending confirmation…", "sending");
					$.ajax({
							url: receipt_url
						, type: "POST"
						, dataType: "html"
						})
						.done(function(response){
							var response_text = $("<div/>").html(response || "").text();
							if (/don't have permission|does not have a valid email address|does not contain tickets/i.test(response_text)) {
								show_resend_ticket_confirmation_feedback($resend_link, "Could not send confirmation. Please try again.", "error");
								return;
							}

							show_resend_ticket_confirmation_feedback($resend_link, "Confirmation sent. Have them check Promotions or Spam.", "sent");
						})
						.fail(function(){
							show_resend_ticket_confirmation_feedback($resend_link, "Could not send confirmation. Please try again.", "error");
						});

					return false;
				});

				$displayed_item.find("input").on("change", function(){

					// For da futrue
					var checkbox_id = $(this).attr('id');

					// Update overall checked in count
					var is_checked;
					if ($(this).is(':checked')) { 
						// Use this just for filtered
						if (checkbox_id.indexOf('filtered_value') !== -1) { 
						 Jelly.Actions.Update_Check_In({'Increment':true});
						}
						is_checked = true;
					}
					else {
						// Use this just for filtered
						if (checkbox_id.indexOf('filtered_value') !== -1) {  
							Jelly.Actions.Update_Check_In({'Decrement':true});
						}
						is_checked = null;
					}

					// Get which checkbox I am
					// TODO - tried to do this neatly using data attributes and it didn't work oh well
					var checkbox_id_delimiter = (checkbox_id.indexOf('filtered_value') !== -1) ? '_filtered_value' : '_value';
					var ticket = parseInt(checkbox_id.split(checkbox_id_delimiter)[0].split('_').pop()) + 1;
					
					// Get checked in count for this row
					var checked_in_count = 0;
					$displayed_item.find('input.Jelly_Check_Box_Input').each(function(){
						if ($(this).is(':checked'))
							checked_in_count++;
					});

					// Get other (filtered/unfiltered) value to avoid a delay bug...

					// Get main list item if this is filtered
					var other_list_item = null;
					if (checkbox_id.indexOf('filtered_value') !== -1) { 
						var other_checkbox_id = '#' + checkbox_id.replace('filtered_value', 'value');
						var other_list_item = Friends_UI.entries.list.find(other_checkbox_id);
					}
					// Get filtered list item if this is main
					else if (Friends_UI.entries.filtered_list){ 
						var other_checkbox_id = '#' + checkbox_id.replace('value', 'filtered_value');
						var other_list_item = Friends_UI.entries.filtered_list.find(other_checkbox_id);
					}
					var $other_list_item = null;
					if (other_list_item && other_list_item.length)
						$other_list_item = other_list_item[0].$el;

					// Set other list item check status
					if ($other_list_item)
						$other_list_item.find("input").prop('checked', (is_checked ? true : false));

					// Gray this row out if completed (and the other row too to avoid a delay)
					if (checked_in_count < $displayed_item.entry.quantity) { 
						$displayed_item.removeClass('Completed');
						if ($other_list_item) $other_list_item.removeClass('Completed');
					}
					else {
						$displayed_item.addClass('Completed');
						if ($other_list_item) $other_list_item.addClass('Completed');
					}

					// Use a real one for unfiltered
					if (checkbox_id.indexOf('filtered_value') == -1) {  
						Jelly.Actions.Update_Check_In({'Count_Checks':true});
					}

					// Submit the action to the server
					Jelly.Actions.Set_Input_Value({Namespace: Friends_UI.entries.check_in_action_namespace, Alias: "entry", Value: $displayed_item.entry.shopping_cart_item_id});
					Jelly.Actions.Set_Input_Value({Namespace: Friends_UI.entries.check_in_action_namespace, Alias: "checked_in", Value: null});
					Jelly.Actions.Set_Input_Value({Namespace: Friends_UI.entries.check_in_action_namespace, Alias: "ticket", Value:ticket});
					Jelly.Actions.Set_Input_Value({Namespace: Friends_UI.entries.check_in_action_namespace, Alias: "is_checked", Value: is_checked});
					Jelly.Handlers.Call_Handler_For_Target({
							Event: "Execute"
						,	Target: $('.Check_In_Action').find('[data-kind="Item"]')[0]
					});

					// Create an update block
					var entry_id = $displayed_item.entry.shopping_cart_item_id;
					if (Friends_UI.entries.block_updates[entry_id]) {
						window.clearTimeout(Friends_UI.entries.block_updates[entry_id]);
					}
					Friends_UI.entries.block_updates[entry_id] = window.setTimeout(
							function() {
								delete Friends_UI.entries.block_updates[entry_id];
							}
						,	6000 // 3000 refresh rate + 2 seconds to register change
					);

					// IDK
					/*
					// Add mobile bugfix handler... maybe just for safari
					// TODO - I don't understand any of this
					if ($('body > #Is_Mobile').css("visibility") == "visible") {
						$(checkbox_namespace + "_" + "label").mouseenter(function(event){
							if (hover_timeouts_hack[checkbox_namespace]) {
								window.clearTimeout(hover_timeouts_hack[checkbox_namespace]);
							}
							else { 
								hover_timeouts_hack_catch[checkbox_namespace] = $("#" + checkbox_namespace + "_" + "value").is(":checked");
							}
							hover_timeouts_hack[checkbox_namespace] = window.setTimeout(function(){
							 		if ($("#" + checkbox_namespace + "_" + "value").is(":checked") == hover_timeouts_hack_catch[checkbox_namespace]) {
							 			$("#" + checkbox_namespace + "_" + "value").click();		
							 		}
							 	}, 
							 	150
						 	);
						});
					}
					*/

				});
			}
		, create_$item: function(entry, filtered) {
				var first_name = $.trim(entry.first_name || "");
				var last_name = $.trim(entry.last_name || "");
				var email_address = $.trim(entry.email_address || "");
				var display_name = $.trim(entry.display_name || "");
				if (!display_name) {
					if (first_name && last_name)
						display_name = last_name + ", " + first_name;
					else
						display_name = last_name || first_name || email_address || "Guest";
				}

				// Create tier name...
				var tier = "";
				var tier_name = entry.tier || "";
				var display_tier = entry.display_tier || tier_name;
				var tier_disambiguation = entry.tier_disambiguation || "";
				if (display_tier != Friends_UI.entries.event_name) {
					tier = tier_disambiguation ? tier_name : display_tier;
				}
				var $tier = $("<span/>").addClass("Tier");
				if (tier) {
					$tier.html(tier);
					if (tier_disambiguation) {
						$tier.append(" ").append(
							$("<span/>")
								.addClass("Tier_Disambiguation")
								.html("· " + tier_disambiguation)
						);
					}
				}

				var has_copy_email_action = Friends_UI.entries.can_view_entry_contact;
				var has_refund_action = Friends_UI.entries.can_refund && entry.can_refund && entry.refund_url;
				var has_resend_ticket_confirmation_action = Friends_UI.entries.can_resend_ticket_confirmation;
				var has_order_email = entry.has_order_email && entry.send_ticket_receipt_url;

				// Create core $item...
				var $entry_actions = (!has_copy_email_action && !has_resend_ticket_confirmation_action && !has_refund_action) ? "" :
					$("<span/>").addClass("Entry_Actions").css({
							flex: "0 0 2.25rem"
						,	textAlign: "left"
						,	position: "relative"
						,	minHeight: "2rem"
						,	display: "flex"
						,	justifyContent: "flex-start"
						,	alignItems: "center"
					}).append(
						$("<span/>").addClass("Entry_Actions_Menu_Wrapper").css({
								display: "inline-flex"
							,	position: "relative"
						}).append(
							$("<button/>")
								.addClass("Entry_Actions_Trigger")
								.attr("type", "button")
								.attr("title", "More actions")
								.attr("aria-label", "More actions")
								.css({
										width: "2rem"
									,	height: "2rem"
									,	minWidth: "2rem"
									,	padding: "0"
									,	border: "0"
									,	background: "transparent"
									,	color: "#555"
									,	display: "inline-flex"
									,	alignItems: "center"
									,	justifyContent: "center"
									,	cursor: "pointer"
								})
								.append(
									$("<i/>")
										.addClass("material-icons")
										.css("fontSize", "1.4rem")
										.html("more_vert")
								)
						).append(
							$("<span/>").addClass("Entry_Actions_Menu").css({
									display: "none"
								,	position: "absolute"
								,	top: "100%"
								,	left: "0"
								,	zIndex: "5"
								,	minWidth: "10.75rem"
								,	marginTop: ".25rem"
								,	background: "#fff"
								,	border: "1px solid #ddd"
								,	borderRadius: "4px"
								,	boxShadow: "0 4px 12px rgba(0,0,0,.16)"
								,	padding: ".25rem 0"
							}).append(!has_copy_email_action ? "" :
								$("<button/>")
									.addClass("Entry_Copy_Email_Link")
									.toggleClass("Disabled", !email_address)
									.attr("type", "button")
									.attr("title", email_address ? "Copy email address" : "No email address")
									.attr("aria-label", "Copy email address")
									.attr("aria-disabled", email_address ? "false" : "true")
									.attr("data-email-address", email_address)
									.prop("disabled", !email_address)
									.data("email-address", email_address)
									.css({
											display: "block"
										,	width: "100%"
										,	border: "0"
										,	background: "transparent"
										,	padding: ".6rem .8rem"
										,	color: email_address ? "#333" : "#aaa"
										,	font: "inherit"
										,	textAlign: "left"
										,	whiteSpace: "nowrap"
										,	cursor: email_address ? "pointer" : "default"
										})
										.html("Copy email address")
								).append(!has_resend_ticket_confirmation_action ? "" :
					$("<button/>")
										.addClass("Entry_Resend_Ticket_Confirmation_Link")
										.toggleClass("Disabled", !has_order_email)
										.attr("type", "button")
										.attr("title", has_order_email ? "Resend confirmation email" : "No order email")
										.attr("aria-label", "Resend confirmation email")
										.attr("aria-disabled", has_order_email ? "false" : "true")
										.attr("data-send-ticket-receipt-url", has_order_email ? entry.send_ticket_receipt_url : "")
										.prop("disabled", !has_order_email)
										.css({
												display: "block"
											, width: "100%"
											, border: "0"
											, background: "transparent"
											, padding: ".6rem .8rem"
											, color: has_order_email ? "#333" : "#aaa"
											, font: "inherit"
											, textAlign: "left"
											, whiteSpace: "normal"
											, lineHeight: "1.25"
											, cursor: has_order_email ? "pointer" : "default"
										})
										.html("Resend confirmation email")
								).append(!has_refund_action ? "" :
								$("<a/>")
									.addClass("Entry_Refund_Link")
									.attr("href", entry.refund_url)
									.attr("title", "Open refund panel")
									.attr("aria-label", "Open refund panel")
									.css({
											display: "block"
										,	padding: ".6rem .8rem"
										,	color: "#333"
										,	textAlign: "left"
										,	whiteSpace: "nowrap"
									})
									.html("Open refund panel")
							)
						)
					);

				$item = $("<li/>").addClass("Values").attr("data-entry-id", entry.shopping_cart_item_id).append(
					$("<div/>").addClass("Inner").append(
						$("<span/>").addClass("Filter_Value Hidden").text(display_name.toLowerCase())
					).append(
						$entry_actions
					).append(
						$("<span/>").addClass("Name").append(
							$("<p/>").text(display_name)
						).append(
							$tier
						)
					).append(
						$("<span/>").addClass("Reward").append((!entry.current_membership) ? "" :
							$("<a/>").addClass("Plain_Link").append(
								$("<i/>").addClass("fa fa-certificate")
							)
						)
					)
				);

				if (entry.initial_pass) { 
				}

				else { 
					// Add checkboxes to $item for each quantity

					$checkbox_group = $("<span/>").addClass("Amount").appendTo($item.find('.Inner'));

					for (var checkbox_index = 0; checkbox_index < entry.quantity; checkbox_index++) { 
						
						// Create unique id per checkbox
						var checkbox_id = entry.shopping_cart_item_id + "_" + checkbox_index;
						var checkbox_namespace = "check_in" + "_" + checkbox_id + (filtered ? '_filtered' : '');

						$checkbox = $("<input/>")
							.attr("type", "checkbox")
							.addClass("Jelly_Check_Box_Input")
							.attr("name", checkbox_namespace)
							.attr("id", checkbox_namespace + "_" + "value");

						// Check the checkbox if it's already attending
						if (entry.attended[checkbox_index]) { 
							$checkbox.attr("checked", "checked");
						}

						// Create checkbox display
						$checkbox_wrapper = $("<span/>").addClass("Input_Checkbox Pretty").append(
							$("<label/>")
								.attr("id", checkbox_namespace + "_" + "label")
								.attr("for", checkbox_namespace + "_" + "value")
								.append($checkbox)
								.append(
									$("<span/>").addClass("Display").append(
										$("<span/>").addClass("Check").append(
											$("<i/>").addClass("fa fa-check icon")
										)
									)
								)
						);
					
						// Add checkbox display to the row
						$checkbox_group.append($checkbox_wrapper);

					}

					// Add a special class to the row if it's already completed
					if (entry.quantity == entry.attended_count) {
						$item.addClass("Completed");
					}
				}

				// Store entry in the row
				$item.entry = entry;

				// Return
				return $item;
			}

		// If there is new data, either add it or replace an element in the list with the new data
		, update_entries: function(update_entries) { 

				// For each updated entry
				$.each(update_entries, function(update_entry_index,update_entry){
					
					// Blocked if recently changed
					if (Friends_UI.entries.block_updates[update_entry.shopping_cart_item_id]) {
						console.log('Check-in update is blocked');
						window.clearTimeout(Friends_UI.entries.block_updates[update_entry.id]);
						delete Friends_UI.entries.block_updates[update_entry.id];
					}

					else { 

						// Update entry table, if it's already in there
						var original_entry = null;
						
						$.each(Friends_UI.entries.entries, function(entry_index, entry) { 
							if (entry.shopping_cart_item_id == update_entry.shopping_cart_item_id) { 
								original_entry = entry;

								// hand off $item .. for airBnB hack
								update_entry.$item = original_entry.$item;
								if (original_entry.filtered_$item) { 
									update_entry.filtered_$item = original_entry.filtered_$item;
								}

								Friends_UI.entries.entries[entry_index] = update_entry;
								return false;
							}
						});

						// Or add it to the entry table
						if (!original_entry)
							Friends_UI.entries.entries.push(update_entry);

						// Create an item for the updated/new entry
						new_$item = Friends_UI.entries.create_$item(update_entry);

						// If the $item already existed in our $items list, replace the inner html with the new inner html
						if (original_entry){
							console.log("updating");
							
							// Update $item
							update_entry.$item.html(new_$item.html());
							if (new_$item.hasClass("Completed"))
								update_entry.$item.addClass("Completed");
							else
								update_entry.$item.removeClass("Completed");

							// Similarly, if the $item already existed in the AirBNB infinity list, replace it with the new content
							if (Friends_UI.entries.list.find(update_entry.$item).length) {
								var list_item = Friends_UI.entries.list.find(update_entry.$item)[0];
								list_item.$el.html(new_$item.html());	

								// And attach new handlers 
								Friends_UI.entries.attach_handlers(list_item.$el);
							}
							else { 
								console.log(update_entry);
								console.log("Couldn't find in main list");
							}						
							
							// Similarly, with filtered lists
							if (update_entry.filtered_$item && Friends_UI.entries.$filtered_list.is(":visible") && Friends_UI.entries.filtered_list.find(update_entry.filtered_$item).length) {

								// Create filtered namespaced version of item
								new_filtered_$item = Friends_UI.entries.create_$item(update_entry, true);
								var filtered_list_item = Friends_UI.entries.filtered_list.find(update_entry.filtered_$item)[0];
								filtered_list_item.$el.html(new_filtered_$item.html());
								
								// Copy Completed classs state
								if (new_filtered_$item.hasClass("Completed"))
									filtered_list_item.$el.addClass("Completed");
								else
									filtered_list_item.$el.removeClass("Completed");

								// Add handlers
								Friends_UI.entries.attach_handlers(filtered_list_item.$el);
							}
						}

						// If the $item didn't exist, add it to an "Incoming" area at the bottom
						else { 
							console.log("appending");

							// If this is new entry, add the item as well (airbnb hack)
							update_entry.$item = new_$item;

							// Add 'incoming' divider if it didn't already exist
							if (Friends_UI.entries.$incoming_divider && !Friends_UI.entries.list.find(Friends_UI.entries.$incoming_divider).length){
								Friends_UI.entries.$incoming_divider = $("<li>")
									.addClass("Divider Incoming")
									.css("background", "#F8C3E3")
									.css("padding", ".65rem")
									.css("padding-left", "1rem")
									.css("font-weight", "bold")
									.css("font-size", "1.1em")
									.css("position", "relative")
									.css("top", "-1px")
									.html('Incoming');
								Friends_UI.entries.$items.push(Friends_UI.entries.$incoming_divider);
								Friends_UI.entries.list.append(Friends_UI.entries.$incoming_divider);
							}

							// Then add the new item 
							Friends_UI.entries.$items.push(new_$item);
							Friends_UI.entries.list.append(new_$item);
							Friends_UI.entries.attach_handlers(new_$item);
						}
					}

				});
			}
		, filter: function(query) {

				// Avoid double filter bug - usually when you move from the search box to a check directly
			 	if (query != Friends_UI.entries.filter_query) {
			 		Friends_UI.entries.filter_query = query;

					// Show all
					if (query == "") {
						Friends_UI.entries.$filtered_list.hide();
						Friends_UI.entries.$list.show();

						// Update check in for the hell of it
						Jelly.Actions.Update_Check_In({'Count_Checks':true});
					}

					// Or make a new filtered list and show it.
					else { 

						Friends_UI.entries.$filtered_list.show();
						Friends_UI.entries.$list.hide();

						// Clear existing AirBNB infinity filtered list
						if (Friends_UI.entries.filtered_list) { 
							Friends_UI.entries.filtered_list.remove();
							Friends_UI.entries.filtered_list = null;
						}

						// Create new AirBNB infinity filtered list
						Friends_UI.entries.filtered_list = new infinity.ListView(Friends_UI.entries.$filtered_list);
						
						// Clear filtered items
						filtered_$items = [];

						// Get filtered entries
						filtered_entries = Friends_UI.entries.entries.filter(function(potential_filtered_entry){
							var filter_value = [
									potential_filtered_entry.first_name || ""
								, potential_filtered_entry.last_name || ""
								, potential_filtered_entry.email_address || ""
							].join(" ").toLowerCase();
							if (filter_value.indexOf(query.toLowerCase()) !== -1)
								return true;
							else
								return false;
						});

						// sort filtered entries
						// ... TODO

						// create filtered items
						$.each(filtered_entries, function(filtered_entry_index, filtered_entry_value){
							new_filtered_$item = Friends_UI.entries.create_$item(filtered_entry_value, true);

							// AirBNB hack
							filtered_entry_value.filtered_$item = new_filtered_$item;
							filtered_$items.push(new_filtered_$item);
						});

						// Display filtered_$items via airbnb infinity
						$.each(filtered_$items, function(filtered_$item_index, filtered_$item_value) { 
							Friends_UI.entries.filtered_list.append(filtered_$item_value);
							Friends_UI.entries.attach_handlers(filtered_$item_value);
						});
					}
				}
			}
	}
	, scan: {
			is_live: false
		,	last_code: null
		,	prevent_invalid_scans: false
		, live_timeout: null
		, last_code_timeout: null
		,	prevent_invalid_scans_timeout: null
		,	keydown_load_timeout: null
		, original_viewport_meta_content: null
		, ios_prevent_pinch_zoom_listener: function() { 
			  if (event.scale !== 1) {event.preventDefault();}
			}
		, keydown_listener: null
		, add_barcode_listener: function (event_id) {

			Friends_UI.scan.keydown_listener = function(){
				if ($('#Barcode_Laser_Input').length) {	
		    	if (event.which == 13) {	
		    		var code = $('#Barcode_Laser_Input').val();
		    		$('#Barcode_Laser_Input').val('');

		    		if (Friends_UI.scan.keydown_load_timeout) {
							window.clearTimeout(Friends_UI.scan.keydown_load_timeout);
							Friends_UI.scan.keydown_load_timeout = null;
		    		}

		    		if (Friends_UI.scan.is_live) {

							// Turn off duplicate preventer
							if (Friends_UI.scan.last_code) {
								Friends_UI.scan.last_code = null;
								if (Friends_UI.scan.last_code_timeout) { 
									window.clearTimeout(Friends_UI.scan.last_code_timeout);
									Friends_UI.scan.last_code_timeout = null;
								}
							}

							Friends_UI.scan.scan_code(event_id, code);
						}
		    	}
		    	else { 
		    		if (!Friends_UI.scan.keydown_load_timeout) {
							if (!Friends_UI.scan.prevent_invalid_scans) {
								$('#Barcode_Validator').empty().hide();
								$('#Barcode_Response').empty().hide();
								$('#Barcode_Loading').show();
							}
			    		Friends_UI.scan.keydown_load_timeout = window.setTimeout(function() { 
			    				Friends_UI.scan.keydown_load_timeout = null;
				    			$('#Barcode_Loading').hide();
								}
								, 2000
							);
			    	}
						$('#Barcode_Laser_Input').val($('#Barcode_Laser_Input').val() + String.fromCharCode(event.which).toLowerCase());
		    	}
		  	} 
		  	else {
		  		$(document).off('keydown', Friends_UI.scan.keydown_listener);
		  	} 
		  	return false;
			};

			// Add keypress listener
		  $(document).on('keydown', Friends_UI.scan.keydown_listener);
		}
		, remove_barcode_listener: function() {
			// Remove keypress listener
			$(document).off('keydown', Friends_UI.scan.keydown_listener);
		}

		, prevent_zoom: function() { 
				// Standard
				var viewport_meta = document.querySelector('meta[name="viewport"]');
				Friends_UI.scan.original_viewport_meta_content = viewport_meta.content;
		    viewport_meta.content = "user-scalable=no, initial-scale=1, maximum-scale=1, minimum-scale=1, width=device-width, height=device-height";

		    // iOS 
		    if (Friends_UI.Is_iOS_Safari) { 
			    Friends_UI.scan.ios_prevent_pinch_zoom_listener = document.addEventListener('touchmove', Friends_UI.scan.ios_prevent_pinch_zoom_listener, Friends_UI.Has_Feature_Passive ? { passive: false } : false);
			  }
			}
		, restore_zoom: function() { 

				if (Friends_UI.scan.original_viewport_meta_content){ 
					var viewport_meta = document.querySelector('meta[name="viewport"]');
					viewport_meta.content = Friends_UI.scan.original_viewport_meta_content;
				}
				
				if (Friends_UI.Is_iOS_Safari)
					document.removeEventListener('touchmove', Friends_UI.scan.ios_prevent_pinch_zoom_listener);
			}

		, scan_code: function(event_id, code) {
				// If code is new 
	  		if (Friends_UI.scan.last_code != code) { 

	  			// Store last result
	        Friends_UI.scan.last_code = code;

		  		// Pause scanning for at most one and a half seconds (when the detail view loads, it'll unpause first
					Friends_UI.scan.is_live = false;
					// console.log("scanning paused");

					if (Friends_UI.scan.live_timeout) { 
						window.clearTimeout(Friends_UI.scan.live_timeout);
						Friends_UI.scan.live_timeout = null;
					}

					Friends_UI.scan.live_timeout = window.setTimeout(function() { 
							if (!Friends_UI.scan.is_live) { 
								// console.log("scanning resumed");
								Friends_UI.scan.is_live = true;
							}
						}
						, 1500
					);

					// TODO - syntax validation could be done here, but it isn't.
					var code_parts, code_cart, code_ticket;
					code_parts = code.split("x"); 
					code_cart = parseInt(code_parts[0]);
					if (code_parts.length > 1)
						code_ticket = parseInt(code_parts[1], 10);
					else 
						code_ticket = "";

	        // Validate code and load detail if valid
	        var scan_response_url = "/event/" + event_id + "/entry_scan_validator/raw:cart="  + code_cart + ",ticket=" + code_ticket + ",original=" + code;

	        if (!Friends_UI.scan.prevent_invalid_scans) {
		        $('#Barcode_Loading').show();
		      }

	        Jelly.References.Fill({
							Element: $('#Barcode_Validator').get(0)
						,	URL: scan_response_url
						, Create_Reference: true
						, On_Load: function(){ 
							$('#Barcode_Loading').hide();
						} 
					});

					// Prevent duplicates for 5 seconds
					if (Friends_UI.scan.last_code_timeout) { 
						window.clearTimeout(Friends_UI.scan.last_code_timeout);
						Friends_UI.scan.last_code_timeout = null;
					}
					Friends_UI.scan.last_code_timeout = window.setTimeout(function() { 
							Friends_UI.scan.last_code = null;

							// TODO - kinda messy
							$('#Barcode_Validator').empty().hide();

							// console.log("Clearing pink 2");								
							var drawingCtx = Quagga.canvas.ctx.overlay, drawingCanvas = Quagga.canvas.dom.overlay;
							drawingCtx.clearRect(0, 0, parseInt(drawingCanvas.getAttribute("width")), parseInt(drawingCanvas.getAttribute("height")));
						}
						, 5000
					);
				}
				else { 
					console.log("duplicate");
				}
			}
	}

	, marketing: {

		change_how_does_it_work: function(new_segment) {
			Jelly.References.Fill({
					Element: $('.wf-how-does-it-work-wrapper').get(0)
				, 	URL: '/block/page_primer_how_does_it_work/' + ':' + Jelly.Utilities.Serialize({
							Values:{
								segment_specific_kind: new_segment
							}
						, Token:','
						, Is_URI:true
					})
				,	Create_Reference: true
			});
		}
		,	change_carousel: function(new_segment) {
			Jelly.References.Fill({
					Element: $('.wf-social-proof-carousel-wrapper').get(0)
				, 	URL: '/block/page_primer_social_proof_carousel/' + ':' + Jelly.Utilities.Serialize({
							Values:{
								current_segment: new_segment
							}
						, Token:','
						, Is_URI:true
					})
				,	Create_Reference: true
			});
		}
		, change_magic_moment: function(new_segment) {
			var segmentUrl = function(slide) {

				return "url(" + (location.protocol + "//" + location.host) + "/segment/" + new_segment.toLowerCase() + "/magic_moment_image/:slide=" + slide + ")";
			};

			var randomTestimonial = function() {
				var magicMomentIds = [4633220, 4597466, 4655600, 4683615, 1280620, 2096338];
				var randomElement = magicMomentIds[Math.floor(Math.random() * (magicMomentIds.length-1))];
				return "url(" + (location.protocol + "//" + location.host) + "/movement_followers/" + randomElement + "/image/:do_regenerate=0)";
			};

			$('#wf-member-calculation').css('background-image', segmentUrl(1));
			$('#wf-testimonials').css('background-image', randomTestimonial());
			$('#wf-graph').css('background-image', segmentUrl(3));
		}
		, change_customers_per_month: function(customersPerMonth, segmentName) {
			if (customersPerMonth < 1) {
				customersPerMonth = 100
			}

			// TODO - This should be automatic...
			switch (segmentName) {
				case 'Food and Drink':
					segmentName = 'Local Business';
					break;
				case 'CSA':
					break;
				default:
					segmentName = segmentName.toLowerCase();
					break;
			}

			var incomePerYear = Math.round(Number(parseFloat(customersPerMonth) * 86.4));
			var incomeString = incomePerYear.toLocaleString('en-US', { 
				style: 'currency', 
				currency: 'USD',
				minimumFractionDigits: 0,
				maximumFractionDigits: 0,
			});
			var topText = "If your " + segmentName + " gets an average of " + customersPerMonth + " customers per month...";
			var bottomText = "...you'll make <strong>" + incomeString + " per year</strong> on Withfriends";
			$('#wf-customers-per-month-top').html(topText);
			$('#wf-customers-per-month-bottom').html(bottomText);
		}
		, change_segment: function(segmentName) {
			var aliasUrl = '/segment/' + segmentName + '/alias';
			var customersUrl = '/segment/' + segmentName + '/customers_per_month';
			var nameUrl = '/segment/' + segmentName + '/name';

			$.get(aliasUrl, function(data) {
				Friends_UI.marketing.change_how_does_it_work(data);
				Friends_UI.marketing.change_carousel(data);
				Friends_UI.marketing.change_magic_moment(data);
			});

			$.get(customersUrl, function(customersPerMonth) {
				$.get(nameUrl, function(segmentName) {
					Friends_UI.marketing.change_customers_per_month(customersPerMonth, segmentName);
				});
			});
		}

		// Receives an array of categories from Foursquare, sorted by most to least specific.
		, fs_change_segment: function(possibleCategories) {
			var categoryMapping = {
				'Arts & Entertainment': 'performing_arts_venue',
				'Food & Drink Shop': 'food_and_drink_business',
				'Food': 'restaurant',
				'Nightlife Spot': 'bar',
				'Bar': 'bar',
				'School': 'educational_venue',
				'College & University': 'educational_venue',
				'Performing Arts Venue': 'performing_arts_venue',
				'Music Venue': 'music_venue',
				'Concert Hall': 'concert_venue',
				'Farm': 'farm',
				'Café': 'coffee_shop',
				'Coffee Shop': 'coffee_shop',
				'Turkish Coffeehouse': 'coffee_shop',
				'Corporate Coffee Shop': 'coffee_shop',
				'Irani Cafe': 'coffee_shop',
				'Record Shop': 'record_store',
				'College Bookstore': 'bookstore',
				'Bookstore': 'bookstore',
				'Used Bookstore': 'bookstore',
				'College Library': 'bookstore',
				'Library': 'bookstore',
				'Arcade': 'arcade'
			};

			var finalCategory = 'local_business';

			for (var idx = 0; idx < possibleCategories.length; idx++) {
				var category = possibleCategories[idx];
				if (categoryMapping[category]) {
					finalCategory = categoryMapping[category];
					break;
				}
			}

			Friends_UI.marketing.change_segment(finalCategory);
		}

		, fs_suggest_callback: function(input_id, value_id, value_name) {
			$input = $("#" + input_id);
			$input.val(value_name);
			$("#fs_search_results").empty().hide();
		}
	}
	, location: {
		// Copied from https://medium.com/better-programming/how-to-detect-the-location-of-your-websites-visitor-using-javascript-92f9e91c095f
			ip_lookup: function () {
				$.ajax('http://api.ipstack.com/check?access_key=487801a89147e51be94238405ebae0e0')
				.then(
						function success(response) {
							// TODO - this is crazy
							$('#location_finder input').val(response.city + ", " + response.region_name);
						}
				     ,	function fail(data, status) {
				         	// console.log('Request failed.  Returned status of', status);
						}
			  );
			}
		,	get_address: function (latitude, longitude) {
				$.ajax('https://maps.googleapis.com/maps/api/geocode/json?latlng=' + latitude + ',' + longitude + '&key=' + 'AIzaSyAoKmZRAe3CHTCE1UVSuFNnl4CJb-Y2_-c')
				.then(
						function success (response) {
							// TODO: This is crazy
				      		$('#location_finder input').val(response.city + ", " + response.region);
				    	}
			    	,	function fail (status) {
					      // console.log('Request failed.  Returned status of',status)
					    }
			   );
			}

		, 	get_location: function(){

				// TODO - unused.
				if ("geolocation" in navigator && false) {
			  		// check if geolocation is supported/enabled on current browser
			  		navigator.geolocation.getCurrentPosition(
						   	function success(position) {
								// for when getting location is a success
								console.log('latitude', position.coords.latitude, 'longitude', position.coords.longitude);
								Friends_UI.location.get_address(position.coords.latitude, position.coords.longitude);
							}
						,	function error(error_message) {
						    	// for when getting location results in an error
						    	console.error('An error has occured while retrieving location', error_message)
				    			Friends_UI.location.ip_lookup()
				 			}
					);
				} 
				else {
					// geolocation is not supported
					// get your location some other way
					// console.log('geolocation is not enabled on this browser')
					Friends_UI.location.ip_lookup();
				}
			}
	}

	,	Frontend: {
			Handle_Header_Last: null
			, Handle_Header: function() {
				if (!$('body').hasClass("Lead") && !$('body').hasClass("wf-add-sticky-header")) {
					var Document_Scroll_Top = $(document).scrollTop();

					if (!Friends_UI.Frontend.Handle_Header_Last || Math.abs(Friends_UI.Frontend.Handle_Header_Last - Document_Scroll_Top) > 5) {
						
						Friends_UI.Frontend.Handle_Header_Last = Document_Scroll_Top;

						if (Document_Scroll_Top >= 11 * Friends_UI.rem) {
							Friends_UI.$UI.addClass("Header_Collapsed Header_Collapse_Completed");
						}
						else if (Document_Scroll_Top > 2 * Friends_UI.rem) {
							Friends_UI.$UI.addClass("Header_Collapsed").removeClass("Header_Collapse_Completed")
								// iPhone Fix 
								.css("z-index", 1)
							;	
							if (Friends_UI.Frontend.Handle_Header_Last < 2 * Friends_UI.rem)
								window.scrollTo(0, 2 * Friends_UI.rem);
						}
						else {
							Friends_UI.$UI.removeClass("Header_Collapsed Header_Collapse_Completed");
						}	
					}
				}

				if ($('body').hasClass("wf-add-sticky-header")) {
					var Document_Scroll_Top = $(document).scrollTop();
					if (!Friends_UI.Frontend.Handle_Header_Last || Math.abs(Friends_UI.Frontend.Handle_Header_Last - Document_Scroll_Top) > 5) {
						Friends_UI.Frontend.Handle_Header_Last = Document_Scroll_Top;
						if (Document_Scroll_Top >= 19 * Friends_UI.rem) {
							Friends_UI.$UI.addClass("wf-show-sticky-header");
						}
						else {
							Friends_UI.$UI.removeClass("wf-show-sticky-header");
						}	
					}
				}

				/*
				if (($(document).scrollTop() + $(window).height()) > ($(document).height() - $(document).height()/2 )) {
					$('#Friends_UI').addClass("Footer_Revealed");
				}
				*/

				if (Friends_UI.$Footer_Trigger) {
					if (Friends_UI.$Footer_Trigger.length) {
						// TODO - IDK what the 1st part does
						if ((Document_Scroll_Top + $(window).height()) > Friends_UI.$Footer_Trigger.offset().top && Document_Scroll_Top > Friends_UI.Footer_Threshold) {
							$('#Friends_UI').addClass("Footer_Revealed")
								// iPhone Fix 
								.css("z-index", 1)
							;
							if (Friends_UI.Is_Mobile) {
								if (('.Scroll_Reveal_Footer').length) {
									$('#intercom-container, , .woot-widget-bubble, .woot-widget-holder').hide();
								}
							}
						}
						else {
							if (Friends_UI.Footer_Return)
								$('#Friends_UI').removeClass("Footer_Revealed");
							if (Friends_UI.Is_Mobile) {
								$('#Friends_UI').removeClass("Footer_Revealed");
								if (('.Scroll_Reveal_Footer').length && !Jelly.Interface.Visible_Modal) {
									$('#intercom-container, .woot-widget-bubble, .woot-widget-holder').show();
								}
							}
						}
					}
					else { 
						Friends_UI.$Footer_Trigger = null;
					}
				}

				// Handle WF logo 
				/*
				if (Friends_UI.$Splash_Trigger) {
					if (!Friends_UI.Is_Mobile) {
						var Splash_Scroll_Start = 	
							// Get top of logo (if absolute)
							Friends_UI.$Video_Trigger.offset().top + 
								((Friends_UI.$Video_Trigger.height() - Friends_UI.$Splash_Trigger.height())/2) - 
							
							// Get top of logo (if fixed)
							(($(window).height() - Friends_UI.$Splash_Trigger.height())/2);

						var Splash_Scroll_Distance = ((Friends_UI.$Video_Trigger.height() - Friends_UI.$Splash_Trigger.height())/2) - (3 * Friends_UI.rem);

						var Splash_Scroll_End = Splash_Scroll_Start + Splash_Scroll_Distance;

						// If scroll height is before 50%, remove classes
						if (Document_Scroll_Top < Splash_Scroll_Start) {
							Friends_UI.$Splash_Trigger.removeClass('Scroll_Start').removeClass('Scroll_End');
						}
						// If scroll height is 50%, add a class, remove class
						else if (Document_Scroll_Top > Splash_Scroll_Start && Document_Scroll_Top < Splash_Scroll_End) {
							Friends_UI.$Splash_Trigger.addClass('Scroll_Start').removeClass('Scroll_End')
								.css('margin-top', 'initial');
							;
						}
						// If scroll height is at threshold, add another class
						else { 
							Friends_UI.$Splash_Trigger.addClass('Scroll_End')
								.css('margin-top', Splash_Scroll_Distance);
						}
					}
				}
				*/
				
				
			}
		,	Adjust_Header: function() { 
				$(".Sizing_Dummy").remove();
				var $X = $('#Content header').clone().addClass('Sizing_Dummy').insertAfter('#Content header'); 
				console.log($X.height());
				$('main').css('padding-top', $X.height());
				$X.remove();
			}
			,	Get_Parent_Size: function(minimumHeight = 1500) {
					var html = document.documentElement || document.getElementsByTagName("html")[0];
					var body = document.body;
					var bodyHeight = 0;
					var htmlContentHeight = 0;
					var currentHeight = minimumHeight;

					if (!html) {
						return currentHeight;
					}

					if (html.classList.contains("Scroll_Lock")) {
						return 2000;
					}

					if (body) {
						bodyHeight = Math.max(
							body.scrollHeight || 0,
							body.offsetHeight || 0,
							body.clientHeight || 0
						);
					}

					htmlContentHeight = Math.max(
						html.offsetHeight || 0,
						bodyHeight
					);

					// In iframes, html.scrollHeight/clientHeight can get pinned to the
					// current iframe viewport and prevent the frame from shrinking again.
					// Prefer real content height, and only fall back to html scroll/client
					// metrics when the body has not established a measurable height yet.
					if (!htmlContentHeight) {
						htmlContentHeight = Math.max(
							html.scrollHeight || 0,
							html.clientHeight || 0
						);
					}

					currentHeight = Math.max(
						minimumHeight,
						htmlContentHeight
					);

					return currentHeight;
				}
			,	Post_Parent_Size: function(minimumHeight = 1500) {
					var currentHeight = Friends_UI.Frontend.Get_Parent_Size(minimumHeight);
					var state = Friends_UI.Frontend._Parent_Size_State || (Friends_UI.Frontend._Parent_Size_State = {});

					if (state.lastHeight === currentHeight) {
						return currentHeight;
					}

					state.lastHeight = currentHeight;
					window.parent.postMessage({
						action: "resizeEmbedFrame",
						value: currentHeight
					}, "*");

					return currentHeight;
				}
			,	Handle_Parent_Size: function(minimumHeight = 1500) {
					var state = Friends_UI.Frontend._Parent_Size_State || (Friends_UI.Frontend._Parent_Size_State = {});

					function requestResize() {
						if (state.pendingFrame && window.cancelAnimationFrame) {
							window.cancelAnimationFrame(state.pendingFrame);
						}

						if (window.requestAnimationFrame) {
							state.pendingFrame = window.requestAnimationFrame(function() {
								state.pendingFrame = null;
								Friends_UI.Frontend.Post_Parent_Size(minimumHeight);
							});
						}
						else {
							Friends_UI.Frontend.Post_Parent_Size(minimumHeight);
						}
					}

					if (state.fastInterval) {
						clearInterval(state.fastInterval);
					}
					if (state.slowInterval) {
						clearInterval(state.slowInterval);
					}
					if (state.slowdownTimeout) {
						clearTimeout(state.slowdownTimeout);
					}
					if (state.resizeObserver) {
						state.resizeObserver.disconnect();
					}
					if (state.handleLoad) {
						window.removeEventListener("load", state.handleLoad);
					}
					if (state.handleWindowResize) {
						window.removeEventListener("resize", state.handleWindowResize);
					}

					state.handleLoad = requestResize;
					state.handleWindowResize = requestResize;

					window.addEventListener("load", state.handleLoad);
					window.addEventListener("resize", state.handleWindowResize);

					if (window.ResizeObserver) {
						state.resizeObserver = new ResizeObserver(function() {
							requestResize();
						});
						state.resizeObserver.observe(document.documentElement);
						if (document.body) {
							state.resizeObserver.observe(document.body);
						}
					}

					requestResize();
					window.setTimeout(requestResize, 0);
					window.setTimeout(requestResize, 250);
					window.setTimeout(requestResize, 1000);

					state.fastInterval = setInterval(requestResize, 175);
					state.slowdownTimeout = setTimeout(function() {
						if (state.fastInterval) {
							clearInterval(state.fastInterval);
							state.fastInterval = null;
						}
						state.slowInterval = setInterval(requestResize, 500);
					}, 60000);
				}
		
		,	Handle_Aspect_Ratio_Fallback: function() {
			console.log("Handling aspect ratio fallback");
			function adjustSquareImage() {
				var covers = document.getElementsByClassName('aspect-ratio-fallback');
				for (var i = 0; i < covers.length; i++) {
					var cover = covers[i];
					var availableHeight = cover.offsetHeight;
					cover.style.width = availableHeight + 'px';
				}
			}
	
			if (window.addEventListener) {
				window.addEventListener('load', adjustSquareImage);
				window.addEventListener('resize', adjustSquareImage);
			} else if (window.attachEvent) {
				window.attachEvent('onload', adjustSquareImage);
				window.attachEvent('onresize', adjustSquareImage);
			}
		}
	}

	// Attach handlers
	,	Start: function() {
		
		Friends_UI.rem = parseInt($('body').css("font-size"));
		Friends_UI.$UI = $('#Friends_UI');

		$(document).scroll(_.throttle(Friends_UI.Frontend.Handle_Header, 100));

		// Get mobile
		if ($('body > #Is_Mobile').css("visibility") == "visible") { 
			Friends_UI.Is_Mobile = true;
		}
		if ($('body > #Is_Tablet').css("visibility") == "visible") { 
			Friends_UI.Is_Tablet = true;
		}

		// Get iOS Safari
		var ua = window.navigator.userAgent;
		Friends_UI.Is_iOS_Safari = (!!ua.match(/iPad/i) || !!ua.match(/iPhone/i)) && (!!ua.match(/WebKit/i)) && !ua.match(/CriOS/i) && !ua.match(/OPiOS/i) && !ua.match(/EdgiOS/i); 


		// Browser Detect Passive
		try {
		  document.addEventListener("test", null, { get passive() { Friends_UI.Has_Feature_Passive = true }});
		} catch(e) {}
		
		// Dropdowns remove active state
		$(document).click(function(){
			$(".Dropdown").removeClass("Active");
		});

		Jelly.Interface.Add_Refresh_Listener(function() { 

			// Dropdowns show active state
			$('.Dropdown').off('click').on('click', function(Click_Event) {
				$(this).toggleClass('Active');
				Click_Event.stopPropagation();
			});

		});

		Jelly.Interface.Add_Refresh_Container_Listener(function() { 

			// Remove force orientation
			Friends_UI.remove_force_orientation();
	 
			// Update Intercom
			$('body').removeClass("Intercom_Remove");
			$('body').removeClass("Intercom_Up");
			if (window.Intercom)
				window.Intercom("update");

			// Show toolbar
			// Delay till rendered...
			setTimeout(function() {
					console.log("checking for lead");

					if (!$('main.Lead').length && !$('.wf-theme-check').length && 
							!$('#Toolbar_Wrapper').is(":visible")
						) {
						console.log("lead not found, wf-theme not found, and toolbar is not already showing, so showing toolbar");

						// TODO - this would really bug out with css so I just fucking moved it to JS
						$('body').removeClass("Lead");	
						$('body').removeClass("wf-theme");	
						$('#Toolbar_Wrapper').css("top", "-500px").css("display", "block").animate({"top":0}, 0, function() {
							$('#Toolbar_Wrapper').css('top', '');
						});
					}
					else { 
						console.log("not changing");
					}
				}
				, 25
			);

			$('body').removeClass("Primer");
			$('body').removeClass("wf-add-sticky-header");

			// Remove themes
			$('.wf-movement-stylesheet').remove();
			$('body').removeClass("is_embedded");

			// Clear FAQ 
			// $('.wf-toolbar').removeClass("wf-organizer");
			// TODO - we changed our plan, so this shows always

			// Clear logo 
			/*
			Friends_UI.$Splash_Trigger = null;
			Friends_UI.$Video_Trigger = null;
			*/
		});

		Jelly.Interface.Call_Refresh_Listeners();

		var supportsAspectRatio = false;
		if (window.CSS && CSS.supports) {
			supportsAspectRatio = CSS.supports('aspect-ratio', '1 / 1');
		}
		if (!supportsAspectRatio) {
			Friends_UI.Frontend.Handle_Aspect_Ratio_Fallback();
		}
	}


	// Kiosk and check-in stuff
	,	force_orientation: function(orientation) {
		var $orientation_disclaimer = $('<div/>')	
			.addClass("Force_Orientation_Disclaimer")
			.addClass(orientation.charAt(0).toUpperCase() + orientation.slice(1))
			.html("Please rotate your screen to " +  orientation + " mode.");
		$('body').append($orientation_disclaimer)
	}
	, remove_force_orientation: function(){
		$(".Force_Orientation_Disclaimer").remove();
	}

	,	Is_Mobile_Or_Tablet_Crude: function() {
		// TODO - lol - https://stackoverflow.com/questions/11381673/detecting-a-mobile-browser

		var check = false;
		(function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
	 	return check;
	}

	,	register_fallback_message: ($fallback_message_element = null, delay = 10000, $fallback_disclaimer_element = null) => {
			if (!$fallback_message_element)
				$fallback_message_element = $('.wf-fallback-message');
			$fallback_message_element.hide();

			if (!$fallback_disclaimer_element)
				$fallback_disclaimer_element = $('.wf-fallback-disclaimer');
			var meta_timeout_element = $('meta[name="withfriends:timeout"]').get(0);

			if (!meta_timeout_element.content)
				meta_timeout_element.content = Date.now();
			else if (Date.now() - parseInt(meta_timeout_element.content) >= delay) {
				$fallback_message_element.show();
				$fallback_disclaimer_element.hide();
			}
		}
	,	clean_fallback_message: ($fallback_message_element = null, $fallback_disclaimer_element = null) => {
			if (!$fallback_message_element)
				$fallback_message_element = $('.wf-fallback-message');
			if (!$fallback_disclaimer_element)
				$fallback_disclaimer_element = $('.wf-fallback-disclaimer');
			var meta_timeout_element = $('meta[name="withfriends:timeout"]').get(0);
			meta_timeout_element.content = "";
			$fallback_message_element.hide();
			$fallback_disclaimer_element.hide();
		}
	, 	gifts: {
			initGiftMembershipGiftEmail: (actionId) => {
				const visibleEmailInput = $(`#${actionId}_gift_email_wrapper`).find('input').first();
				const hiddenGiftEmailInput = $(`#${actionId}_gift_email_hidden_wrapper`).find('input').first();
				const checkbox = $(`#${actionId}_no_recipient_email`);

				// Mirror recipient email -> hidden gift email whenever we're NOT in no-email mode.
				visibleEmailInput.off('input.giftEmailMirror').on('input.giftEmailMirror', () => {
					if (!checkbox.is(':checked')) {
						hiddenGiftEmailInput.val((visibleEmailInput.val() || '').trim()).change();
					}
				});

				// Initialize hidden value on load
				if (!checkbox.is(':checked')) {
					hiddenGiftEmailInput.val((visibleEmailInput.val() || '').trim()).change();
				} else {
					Friends_UI.gifts.toggleNoEmailMode(actionId);
				}
			},
			setGiftDurationText: (namespace, giftDuration, membershipKind) => {
				let giftDurationText = "";
				switch (membershipKind) {
					case "Weekly":
						giftDurationText = 'This membership will renew weekly.  You can cancel renewal at any time.';
						break;
					case "Annual":
						switch (giftDuration) {
							case 0:
								giftDurationText = 'This membership will renew annually. You can cancel renewal at any time.';
								break;
							case 12:
								giftDurationText = 'This membership lasts for one year and will not renew. Afterwards, your recipient will have a chance to pay to continue.';
								break;
							case 24:
								giftDurationText = 'This membership will renew annually for two years. Afterwards, your recipient will have a chance to pay to continue.';
								break;
							case 36:
								giftDurationText = 'This membership will renew annually for three years. Afterwards, your recipient will have a chance to pay to continue.';
								break;
						}
						break;
					case "Monthly":
						switch (giftDuration) {
							case 0:
								giftDurationText = 'This membership will renew monthly. You can cancel renewal at any time.';
								break;
							case 1:
								giftDurationText = 'This membership lasts for 1 month and will not renew. Afterwards, your recipient can pay to continue their membership.';
								break;
							case 3:
							case 6:
							case 12:
								giftDurationText = `This membership will renew monthly for ${giftDuration < 12 ? giftDuration + " months" : "1 year"}. After renewal ends, your recipient can pay to continue their membership.`;
								break;
						}
						break;
				}
				$(`#${namespace} .gift-duration-text`).text(giftDurationText);
			},
			toggleNoEmailMode: (actionId) => {
				const checkbox = $(`#${actionId}_no_recipient_email`);
				const emailLabel = $(`#${actionId}_email_label`);
				const visibleEmailInput = $(`#${actionId}_gift_email_wrapper`).find('input').first();
				const hiddenGiftEmailInput = $(`#${actionId}_gift_email_hidden_wrapper`).find('input').first();
				const extrasDiv = $(`#${actionId}_no_email_extras`);
				const identifierInput = $(`#${actionId}_gift_identifier_wrapper`).find('input').first();
				const loggedInEmail = $(`#${actionId}_logged_in_email`).val();
				const isLoggedIn = !!loggedInEmail;
				
				if (checkbox.is(':checked')) {
					// Switch to no-email mode
					extrasDiv.show();
					identifierInput.prop('required', true);
					
					if (isLoggedIn) {
						// User is logged in - hide the main email input and use their email
						emailLabel.hide();
						$(`#${actionId}_gift_email_wrapper`).hide();
						visibleEmailInput.prop('required', false);
						hiddenGiftEmailInput.data('baseEmail', loggedInEmail);
					} else {
						// User not logged in - change label to ask for their email
						emailLabel.html('Your email <span style="font-weight:normal; font-size:0.9em;">(to manage this membership)</span>');
						visibleEmailInput.attr('placeholder', 'your@email.com');
						// Store the current email as base email (strip any +gift_ suffix if present)
						const currentEmail = (visibleEmailInput.val() || '').trim();
						const baseEmail = Friends_UI.gifts.extractBaseEmail(currentEmail);
						visibleEmailInput.val(baseEmail);
						hiddenGiftEmailInput.data('baseEmail', baseEmail);
					}
					
					// Pre-fill identifier with recipient's first name if not already set
					Friends_UI.gifts.prefillIdentifier(actionId);
					
					// Set up listeners for constructing the email
					Friends_UI.gifts.setupNoEmailListeners(actionId);
					Friends_UI.gifts.updateConstructedEmail(actionId);
				} else {
					// Switch back to normal mode
					emailLabel.text('Recipient email').show();
					$(`#${actionId}_gift_email_wrapper`).show();
					visibleEmailInput.prop('required', true);
					visibleEmailInput.attr('placeholder', 'name@site.com');
					extrasDiv.hide();
					identifierInput.prop('required', false);
					
					hiddenGiftEmailInput.removeData('baseEmail');
					
					// Remove listeners
					visibleEmailInput.off('input.noEmailMode');
					identifierInput.off('input.noEmailMode');
					$(`#${actionId}_gift_name_wrapper`).find('input').first().off('input.noEmailMode');

					// In normal mode, hidden gift email should mirror the visible recipient email
					hiddenGiftEmailInput.val((visibleEmailInput.val() || '').trim()).change();
				}
			},
			extractBaseEmail: (email) => {
				// Remove +gift_xxx suffix if present
				return email.replace(/\+gift_[^@]*(@)/, '$1');
			},
			prefillIdentifier: (actionId) => {
				// Query elements fresh to ensure we get the right ones
				const giftNameInput = $(`#${actionId}_gift_name_wrapper`).find('input').first();
				const identifierInput = $(`#${actionId}_gift_identifier_wrapper`).find('input').first();
				
				// Make sure we found the identifier input
				if (identifierInput.length === 0) {
					console.warn('Gift identifier input not found');
					return;
				}
				
				// Only prefill if identifier hasn't been manually edited
				if (!identifierInput.data('manuallyEdited') && !(identifierInput.val() || '').trim()) {
					const fullName = (giftNameInput.val() || '').trim();
					if (fullName) {
						// Get first name (first word)
						const firstName = fullName.split(/\s+/)[0];
						identifierInput.val(firstName);
					}
				}
			},
			setupNoEmailListeners: (actionId) => {
				// Helper to get elements fresh each time (avoid stale closures)
				const getVisibleEmailInput = () => $(`#${actionId}_gift_email_wrapper`).find('input').first();
				const getHiddenGiftEmailInput = () => $(`#${actionId}_gift_email_hidden_wrapper`).find('input').first();
				const getIdentifierInput = () => $(`#${actionId}_gift_identifier_wrapper`).find('input').first();
				const getGiftNameInput = () => $(`#${actionId}_gift_name_wrapper`).find('input').first();
				const loggedInEmail = $(`#${actionId}_logged_in_email`).val();
				const isLoggedIn = !!loggedInEmail;
				
				// Remove any existing listeners to prevent duplicates
				getVisibleEmailInput().off('input.noEmailMode');
				getIdentifierInput().off('input.noEmailMode');
				getGiftNameInput().off('input.noEmailMode');
				
				// When user types in visible email field, extract base email and update constructed
				// (only if not logged in - logged in users can't edit their email)
				if (!isLoggedIn) {
					getVisibleEmailInput().on('input.noEmailMode', () => {
						const visibleEmailInput = getVisibleEmailInput();
						const currentVal = (visibleEmailInput.val() || '').trim();
						const baseEmail = Friends_UI.gifts.extractBaseEmail(currentVal);
						getHiddenGiftEmailInput().data('baseEmail', baseEmail);
						Friends_UI.gifts.updateConstructedEmail(actionId);
					});
				}
				
				getIdentifierInput().on('input.noEmailMode', () => {
					// Mark as manually edited when user types
					getIdentifierInput().data('manuallyEdited', true);
					Friends_UI.gifts.updateConstructedEmail(actionId);
				});
				
				// Sync identifier with recipient name if not manually edited
				getGiftNameInput().on('input.noEmailMode', () => {
					const identifierInput = getIdentifierInput();
					if (!identifierInput.data('manuallyEdited')) {
						const fullName = (getGiftNameInput().val() || '').trim();
						const firstName = fullName ? fullName.split(/\s+/)[0] : '';
						identifierInput.val(firstName);
						Friends_UI.gifts.updateConstructedEmail(actionId);
					}
				});
			},
			updateConstructedEmail: (actionId) => {
				const hiddenGiftEmailInput = $(`#${actionId}_gift_email_hidden_wrapper`).find('input').first();
				const loggedInEmail = $(`#${actionId}_logged_in_email`).val();
				const baseEmail = hiddenGiftEmailInput.data('baseEmail') || (loggedInEmail || '');
				const identifier = ($(`#${actionId}_gift_identifier_wrapper`).find('input').first().val() || '').trim();
				const previewSpan = $(`#${actionId}_constructed_email`);
				
				if (baseEmail && identifier) {
					// Split email at @ and insert +gift_identifier
					const atIndex = baseEmail.indexOf('@');
					if (atIndex > 0) {
						// Sanitize identifier: only alphanumeric and underscores
						const sanitizedIdentifier = identifier.replace(/[^a-zA-Z0-9_]/g, '_').toLowerCase();
						const constructedEmail = baseEmail.slice(0, atIndex) + '+gift_' + sanitizedIdentifier + baseEmail.slice(atIndex);
						previewSpan.text(constructedEmail);
						// Submit constructed email via the hidden gift email input (do NOT overwrite visible field)
						hiddenGiftEmailInput.val(constructedEmail).change();
					} else {
						previewSpan.text('—');
					}
				} else if (baseEmail && !identifier) {
					previewSpan.text('(enter an identifier)');
					hiddenGiftEmailInput.val(baseEmail).change();
				} else {
					previewSpan.text('—');
				}
			}
		}
};
